module.exports = __webpack_public_path__ + "static/media/16UNODC7.b65625c9.jpg";